import { render, staticRenderFns } from "./EnrollmentOrderForm.vue?vue&type=template&id=254d1c1c&scoped=true&"
import script from "./EnrollmentOrderForm.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentOrderForm.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentOrderForm.vue?vue&type=style&index=0&id=254d1c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d1c1c",
  null
  
)

export default component.exports